<div
  #modalbackground
  *ngIf="isOpen"
  class="background"
  (click)="closeFromBackground($event)"
></div>
<div
  class="date-picker-container"
  [class.inverted]="isInvertedDirection"
  *ngIf="isOpen"
  (click)="onContainerClick($event)"
  (touchstart)="onContainerTouchStart($event)"
>
  <div class="wrapper day-view" *ngIf="viewType === 'Day'">
    <div class="header-row">
      <div class="arrow disabled" *ngIf="!isPrevButtonAvailable"></div>
      <div
        *ngIf="isPrevButtonAvailable"
        class="arrow"
        (click)="shiftMonthUp(false, $event)"
        (keydown)="onKeyAction($event, false)"
        tabindex="-1"
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.75 1L1 6.75L6.75 12.5" stroke="inherit" />
        </svg>
      </div>
      <div class="month">
        <span *ngIf="availableMonths.length === 1" class="view-only">{{
          monthDisplayed.name
        }}</span>
        <span
          class="clickable"
          *ngIf="availableMonths.length > 1"
          (click)="switchMonth($event)"
          >{{ monthDisplayed.name | translate }}</span
        >&nbsp;&nbsp;
        <span *ngIf="yearsListView.length === 1" class="view-only">{{
          formatYear(monthDisplayed.date.getFullYear())
        }}</span>
        <span
          *ngIf="yearsListView.length > 1"
          class="clickable"
          (click)="switchYear($event)"
          >{{ formatYear(monthDisplayed.date.getFullYear()) }}</span
        >
      </div>
      <div class="arrow right disabled" *ngIf="!isNextButtonAvailable"></div>
      <div
        *ngIf="isNextButtonAvailable"
        class="arrow right"
        (click)="shiftMonthUp(true, $event)"
        (keydown)="onKeyAction($event, true)"
        tabindex="-1"
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 12.5L6.75 6.75L1 1" stroke="inherit" />
        </svg>
      </div>
    </div>
    <div class="weekday-row">
      <div *ngFor="let dn of dayNames" class="weekday">
        {{ dn | translate }}
      </div>
    </div>
    <div class="days-grid" [class.custom-layout]="daysDisplayed.length <= 35">
      <div
        *ngFor="let day of daysDisplayed; index as i"
        id="{{ i + startingFocusIndex + 3 }}"
        class="calendar-day"
        [class.current-month]="isDateInMonth(day)"
        [class.selected]="isSelectedDay(day)"
        [class.today]="isTodayDate(day)"
        [class.maximum]="isMaxReached"
        [class.disabled]="isDisabled(day)"
        (click)="onSelectDate(day, $event)"
        (keydown)="onKeyAction($event, day)"
        tabindex="-1"
      >
        {{ day.getDate() }}
      </div>
    </div>
    <div class="action-buttons">
      <div class="today-btn" *ngIf="isTodayAvailable" (click)="showToday($event)">
        {{ 'datePicker.today' | translate }}
      </div>
      <!-- <div
        class="today-btn"
        *ngIf="isShowSelectedAvailable"
        (click)="showSelected()"
      >
        Selected
      </div> -->
      <div
        class="clear"
        *ngIf="selectedDates?.length > 0"
        (click)="onClearSelection($event)"
      >
        {{ 'datePicker.deselect' | translate }}
      </div>
      <div class="clear" *ngIf="selectedDates?.length === 0" (click)="close($event)">
        {{ 'common.close' | translate }}
      </div>
    </div>
  </div>

  <div class="wrapper month-view" *ngIf="viewType === 'Month'">
    <div class="header-row">
      <div
        class="arrow"
        (click)="switchDay($event)"
        (keydown)="onKeyAction($event, false)"
        tabindex="-1"
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.75 1L1 6.75L6.75 12.5" stroke="inherit" />
        </svg>
      </div>
      <div class="month">
        <span>{{ monthDisplayed.name }}</span>
      </div>
    </div>
    <div class="months-grid">
      <div
        *ngFor="let month of availableMonths; index as i"
        id="{{ i + startingFocusIndex + 3 }}"
        class="calendar-month"
        (click)="onSelectMonth(month, $event)"
        (keydown)="onKeyAction($event, day)"
        tabindex="-1"
        [class.selected]="month === monthDisplayed.name"
      >
        {{ month | translate }}
      </div>
    </div>
    <div class="space-delimiter"></div>
    <div class="action-buttons">
      <div class="clear" (click)="reset($event)">
        {{ 'datePicker.reset' | translate }}
      </div>
    </div>
  </div>

  <div class="wrapper years-view" *ngIf="viewType === 'Year'">
    <div class="header-row">
      <div
        class="arrow"
        (click)="switchMonth($event)"
        (keydown)="onKeyAction($event, false)"
        tabindex="-1"
      >
        <svg
          width="8"
          height="13"
          viewBox="0 0 8 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6.75 1L1 6.75L6.75 12.5" stroke="inherit" />
        </svg>
      </div>
      <div class="month">
        <span>{{ formatYear(monthDisplayed.date.getFullYear()) }}</span>
      </div>
    </div>
    <div class="years-grid">
      <div
        *ngFor="let year of yearsListView; index as i"
        id="{{ i + startingFocusIndex + 3 }}"
        class="calendar-year"
        (click)="onSelectYear(year, $event)"
        (keydown)="onKeyAction($event, day)"
        tabindex="-1"
        [class.selected]="year === monthDisplayed.date.getFullYear()"
      >
        {{ formatYear(year) }}
      </div>
    </div>
    <div class="space-delimiter"></div>
    <div class="action-buttons">
      <div class="clear" (click)="reset($event)">
        {{ 'datePicker.reset' | translate }}
      </div>
    </div>
  </div>
</div>
